import type { CentraProduct } from "@/lib/centra/atomicSetup";
import { dataComposer } from "@frend-digital/centra-legacy";

import { ErrorLevel } from "@frend-digital/utils";
import { getMediaObjects } from "../../atomics/media";

const getProductGallery = (product: CentraProduct) => {
  const mediaObjects = getMediaObjects(product, "full");

  const image = {
    data: mediaObjects[0],
    error: undefined,
    errorLevel: ErrorLevel.None,
  };
  const altImage = {
    data: mediaObjects.find(media => !!media.isPackshot) || mediaObjects[1],
    error: undefined,
    errorLevel: ErrorLevel.None,
  };

  const standardProductCardGallery = dataComposer({
    image,
    altImage,
  });

  return standardProductCardGallery;
};

export default getProductGallery;
